import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';
import { NavItem, NavItemType } from '../../../Common/Layout/components/Navbar/navbar.component';
import { HubspotFormTypeEnum } from '../../../Common/Misc/enums/hubspot-form-type.enum';
import { ManageMailingListsDialogComponent } from '../../../Common/MailingLists/components/ManageMailingListsDialog/manage-mailing-lists-dialog.component';
import { ProminenceTakeOverPanelComponent } from '../../../Account/AccountPreferences/components/ProminenceTakeOverPanel/prominence-take-over-panel.component';
import { RSSFeedManageDialogComponent } from '../../../Monitor/Shared/components/RSSFeedManageDialog/rss-feed-manage-dialog.component';
import { ManageStylesDialogComponent } from '../../../Common/Styles/components/ManageStylesDialog/manage-styles-dialog.component';
import { ManageTagsDialogComponent } from '../../../Common/Tags/components/ManageTagsDialog/manage-tags-dialog.component';
import { ManageSourcesDialogComponent } from '../../../Common/Sources/components/ManageSourcesDialog/manage-sources-dialog.component';
import {
    ManageContentLibraryDialogComponent
} from '../../../Common/ContentLibrary/components/ManageContentLibraryDialog/manage-content-library-dialog.component';

import { mediaRelationsNavItem } from './media-relations-nav-item';
import { mediaIntelligenceNavItem } from './media-intelligence-nav-item';
import { supportNav } from '../supportNavigation/support-nav.config';
import { socialNavItem } from './social-nav-item.config';
import { ManageSocialTopicsDialogComponent } from '../../../Social/Intelligence/components/ManageSocialTopicsDialog/manage-social-topics-dialog.component';
import { ManageApiKeysDialogComponent } from '../../../Admin/AccountManagement/components/ApiKeysManagement/manage-api-keys-dialog.component';
import {
    CustomPromptsManagementDialogComponent
} from '../../../Admin/AccountManagement/components/CustomPromptsManagement/custom-prompts-management-dialog.component';
import { MediaSubscriptionQuotaUsageWidgetComponent } from '../../../Social/Shared/components/QuotaUsageWidget/media-subscription-quota-usage-widget.component';
import { SocialListeningQuotaUsageWidgetComponent } from '../../../Social/Shared/components/QuotaUsageWidget/social-listening-quota-usage-widget.component';
import { ManageTemplateDialogComponent } from '../../../Common/MonitorShared/components/ManageTemplateDialog/manage-template-dialog.component';
import { GhostInDialogComponent } from '../../../Common/Dialogs/components/GhostInDialog/ghost-in-dialog.component';
import { UserStateModel } from '../../../Core/Users/models/user-state.model';
import { partnerResellerConfigs } from '../resellers/reseller-config-model';
import { ConfigService } from '../../../Core/Config/services/config.service';
import { MentionSavingUsageDashboardComponent } from '../../../Monitor/Shared/components/MentionSavingUsageDashboard/mention-saving-usage-dashboard.component';
import { ManageDigestsDialogComponent } from '../../../Monitor/Shared/components/ManageDigestDialog/manage-digests-dialog.component';
import {
    ManageBrandIdentitiesDialogComponent
} from '../../../Common/BrandIdentity/components/ManageBrandIdentitiesDialog/manage-brand-identities-dialog.component';


export const primaryNav: {left: NavItem[]; right: NavItem[]; supportLinks: NavItem[]} = {
    left: [
        mediaRelationsNavItem,
        mediaIntelligenceNavItem,
        socialNavItem
    ],
    right: [
        {
            collapsed: false,
            label: 'Core.navigation.account',
            permissions: [
                userPermissionsEnum.account
            ],
            id: 'primaryNavAccounts',
            items: [
                // The current account preference only has monitoring prominence setting, so only show account preference if account has AM permission
                {
                    label: 'Core.navigation.account.accountPreferences',
                    icon: 'fa-duotone fa-regular fa-sliders',
                    routerLink: '/AccountPrefs',
                    id: 'primaryNavAccountPreferences',
                    permissionsValidator(permissions: userPermissionsEnum[]) {
                        return permissions.includes(userPermissionsEnum.advancedMonitoring);
                    },
                },
                {
                    label: 'Core.navigation.account.userPreferences',
                    icon: 'fa-kit-duotone fa-agpr-user-pref',
                    routerLink: '/UserPreferences',
                    id: 'primaryNavUserPreferences',
                    permissions: [
                        userPermissionsEnum.advancedTargeting,
                        userPermissionsEnum.advancedMonitoring,
                        userPermissionsEnum.socialIntelligence
                    ],
                },
                {
                    label: 'Core.navigation.brandManagement',
                    icon: 'fa-kit-duotone fa-agpr-brand-identity',
                    collapsed: true,
                    id: 'primaryNavBrandManagement',
                    items: [
                        {
                            label: 'Core.navigation.brandManagement.visibilityIntelligence',
                            id: 'primaryNavBrandManagementVisibilityIntelligence',
                            permissionsValidator(permissions: userPermissionsEnum[]) {
                                return (
                                    permissions.includes(userPermissionsEnum.openAI)
                                    && permissions.includes(userPermissionsEnum.visibilityIntelligence)
                                );
                            },
                            routerLink: '/visibility-intelligence',
                            disabledTooltip: 'Core.navigation.mediaRelations.visibilityIntelligence.disabled',
                            // TODO: NEP-38233 - Only a placeholder text to enable the lock/upsell behavior,
                            // add more information once marketing message is received.
                            upsellMessage: 'visibility Intelligence Upsell',
                            upsellPopup: {
                                // Placeholder values below - AnalysisUpsellPopupComponent is never opened for VI
                                // (see NavbarComponent.openSubItemUpsell), so this content is never shown. Required
                                // only to satisfy NavItemUpsellPopup's shape until marketing message is received.
                                icon: 'fa-kit-duotone fa-agpr-ai-visibility',
                                heading: 'Visibility Intelligence',
                                message: 'Visibility Intelligence',
                                bullets: ['Visibility Intelligence'],
                                endMessage: 'Visibility Intelligence',
                                featureName: 'Visibility Intelligence',
                                // TODO: NEP-38233 - switch back to HubspotFormTypeEnum.VISIBILITY_INTELLIGENCE once that form
                                // field (upsell_inquiry10-<formId>) exists on the HubSpot side - reusing AGENTIC_FEATURES for now
                                hubspotFormType: HubspotFormTypeEnum.AGENTIC_FEATURES,
                                confirmationHeading: 'Core.navigation.mediaRelations.visibilityIntelligence.upsell.confirmation.heading',
                                confirmationMessage: 'Core.navigation.mediaRelations.visibilityIntelligence.upsell.confirmation.message'
                            }
                        },
                        {
                            label: 'Core.navigation.brandManagement.brandIdentities',
                            id: 'primaryNavBrandManagementBrandIdentities',
                            permissions: [
                                userPermissionsEnum.socialIntelligence,
                                userPermissionsEnum.advancedMonitoring,
                                userPermissionsEnum.advancedTargeting
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageBrandIdentitiesDialogComponent
                        }
                    ]
                },
                {
                    label: 'Core.navigation.contentManagement',
                    icon: 'fa-duotone fa-regular fa-folder-gear',
                    collapsed: true,
                    id: 'primaryNavContentManagement',
                    items: [
                        {
                            label: 'Core.navigation.contentManagement.apiKeys',
                            id: 'primaryNavContentManagementApiKeys',
                            permissionsValidator(permissions: userPermissionsEnum[]) {
                                return (
                                    permissions.includes(userPermissionsEnum.mediaMonitoringApi)
                                    && permissions.includes(userPermissionsEnum.apiKeyManagement)
                                );
                            },
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageApiKeysDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.customPrompts',
                            id: 'primaryNavContentManagementCustomPrompts',
                            permissions: [
                                userPermissionsEnum.openAI
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: CustomPromptsManagementDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.fileDownloads',
                            routerLink: '/FileDownloads',
                            id: 'primaryNavContentManagementFileDownloads',
                            permissions: [
                                userPermissionsEnum.socialIntelligence,
                                userPermissionsEnum.advancedMonitoring
                            ]
                        },
                        {
                            label: 'Core.navigation.contentManagement.contentLibraries',
                            id: 'primaryNavContentManagementContentLibraries',
                            permissions: [
                                userPermissionsEnum.socialIntelligence,
                                userPermissionsEnum.advancedMonitoring,
                                userPermissionsEnum.advancedTargeting
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageContentLibraryDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.dataConnections',
                            routerLink: '/DataConnector',
                            id: 'primaryNavContentManagementDataConnections',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring,
                                userPermissionsEnum.advancedTargeting,
                                userPermissionsEnum.socialIntelligence,
                            ],
                        },
                        {
                            label: 'Core.navigation.contentManagement.digest',
                            id: 'primaryNavContentManagementDigest',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring,
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageDigestsDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.mailingLists',
                            id: 'primaryNavContentManagementMailingLists',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring,
                                userPermissionsEnum.advancedTargeting,
                                userPermissionsEnum.advancedMonitoringManager,
                                userPermissionsEnum.advancedMonitoringFullText
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageMailingListsDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.prominence',
                            id: 'primaryNavContentManagementProminence',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ProminenceTakeOverPanelComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.RSSFeeds',
                            id: 'primaryNavContentManagementRSSFeeds',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: RSSFeedManageDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.sourceGroups',
                            id: 'primaryNavContentManagementSourceGroups',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageSourcesDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.styles',
                            id: 'primaryNavContentManagementStyles',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring,
                                userPermissionsEnum.advancedTargeting,
                                userPermissionsEnum.advancedMonitoringManager,
                                userPermissionsEnum.advancedMonitoringFullText,
                                userPermissionsEnum.newswire,
                                userPermissionsEnum.newsroom
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageStylesDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.tags',
                            id: 'primaryNavContentManagementTags',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageTagsDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.templates',
                            id: 'primaryNavContentManagementTemplates',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring,
                                userPermissionsEnum.advancedTargeting,
                                userPermissionsEnum.advancedMonitoringManager,
                                userPermissionsEnum.advancedMonitoringFullText,
                                userPermissionsEnum.newswire,
                                userPermissionsEnum.newsroom
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageTemplateDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.agents',
                            id: 'primaryNavContentManagementAgents',
                            permissions: [
                                userPermissionsEnum.socialIntelligence
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: ManageSocialTopicsDialogComponent
                        },
                        {
                            label: 'Core.navigation.contentManagement.savedFilters',
                            id: 'primaryNavContentManagementSavedFilters',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring
                            ],
                            type: NavItemType.dialog,
                            dialogReference: 'SavedFilterManageDialogComponent'
                        }
                    ]
                },
                {
                    id: 'primaryNavQuotaUsageDashboards',
                    label: 'Core.navigation.quotaUsageDashboards',
                    icon: 'fa-kit-duotone fa-agpr-quota',
                    collapsed: true,
                    items: [
                        {
                            id: 'primaryNavQuotaUsageDashboardsMentionSaving',
                            label: 'Core.navigation.quotaUsageDashboards.mentionSaving',
                            permissions: [
                                userPermissionsEnum.advancedMonitoring
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: MentionSavingUsageDashboardComponent
                        },
                        {
                            id: 'primaryNavQuotaUsageDashboardsMediaSubscription',
                            label: 'Core.navigation.quotaUsageDashboards.mediaSubscription',
                            permissions: [
                                userPermissionsEnum.mediaSubscriptions
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: MediaSubscriptionQuotaUsageWidgetComponent
                        },
                        {
                            id: 'primaryNavQuotaUsageDashboardsSocialListening',
                            label: 'Core.navigation.quotaUsageDashboards.socialListening',
                            permissions: [
                                userPermissionsEnum.socialIntelligence
                            ],
                            type: NavItemType.takeOverPanel,
                            dialogReference: SocialListeningQuotaUsageWidgetComponent
                        },
                    ]
                },
                {
                    label: 'Core.navigation.sso',
                    icon: 'fa-duotone fa-regular fa-shield-check',
                    routerLink: '/AuthManagement',
                    id: 'primaryNavAuthManagement',
                    showFunction(userStateModel: UserStateModel, configService: ConfigService) {
                        return partnerResellerConfigs.get(configService.getPartnerReseller())?.enableSSO;
                    }
                },
                {
                    label: 'Core.navigation.account.password',
                    icon: 'fa-kit-duotone fa-agpr-password-change',
                    routerLink: '/ChangePassword',
                    id: 'primaryNavChangePassword'
                },
                {
                    label: 'Core.navigation.account.logout',
                    icon: 'fa-duotone fa-regular fa-right-from-bracket',
                    routerLink: '/Logout',
                    id: 'primaryNavLoginSignout'
                },
                {
                    id: 'primaryNavAccountList',
                    type: NavItemType.accountList
                }
            ]
        },
        {
            label: 'Core.navigation.admin',
            permissionsValidator(permissions: userPermissionsEnum[]) {
                return (
                    permissions.includes(userPermissionsEnum.accountManager)
                    || permissions.includes(userPermissionsEnum.accountsReadOnlyManager)
                    || permissions.includes(userPermissionsEnum.accountGhostIn)
                );
            },
            id: 'primaryNavAdmin',
            items: [
                {
                    label: 'Core.navigation.admin.accountManagement',
                    icon: 'fa-kit-duotone fa-agpr-management',
                    routerLink: '/AccountManagement',
                    id: 'primaryNavAccountManagement',
                    permissions: [
                        userPermissionsEnum.accountManager,
                        userPermissionsEnum.accountsReadOnlyManager
                    ]
                },
                {
                    // neptune notifications
                    label: 'Core.navigation.admin.notifications',
                    icon: 'fa-duotone fa-regular fa-bell-ring',
                    routerLink: '/Notifications',
                    id: 'primaryNavNotifications',
                    showFunction(userStateModel: UserStateModel) {
                        return userStateModel.account.partnerResellerId === null;
                    },
                    permissions: [
                        userPermissionsEnum.accountManager
                    ]
                },
                {
                    label: 'Core.navigation.admin.userManagement',
                    icon: 'fa-duotone fa-regular fa-user-gear',
                    routerLink: '/AccountManagement/user',
                    id: 'primaryNavUserManagement',
                    permissions: [
                        userPermissionsEnum.accountManager,
                        userPermissionsEnum.accountsReadOnlyManager
                    ]
                },
                {
                    label: 'Core.navigation.admin.ghost',
                    icon: 'fa-duotone fa-regular fa-ghost',
                    id: 'primaryNavGhostSession',
                    type: NavItemType.dialog,
                    permissionsValidator(permissions: userPermissionsEnum[]) {
                        return (
                            permissions.includes(userPermissionsEnum.accountGhostIn)
                        );
                    },
                    permissions: [
                        userPermissionsEnum.accountGhostIn
                    ],
                    dialogReference: GhostInDialogComponent,
                },
            ]
        }
    ],
    supportLinks: supportNav
};
